<div id="find-vehicle" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="maint-title bold color-grey uk-text-uppercase">
                    Ajouter un nouveau <br>véhicule
                </h2>
                <div class="uk-margin">
                    <label class="label">Rechercher un véhicule</label>
                    <div class="uk-form-controls uk-margin-small-top uk-position-relative">
                        <span *ngIf="loading === false" class="uk-form-icon uk-form-icon-flip" style="top: -5px;">
                            <img src="../../../assets/icons/Search.svg" width="24px" height="24px" alt="user"/>
                        </span>
                        <span *ngIf="loading === true" class="uk-form-icon uk-form-icon-flip">
                            <div style="width:24px; height: 24px;" uk-spinner></div>
                        </span>
                        <input class="input alt bold color-cold-grey uk-width-1-1" type="text" [(ngModel)]="vehicleSearch"
                            (ngModelChange)="updateVehicleOptionList($event)"
                            (focus)="toggleSuggestions(true)" (focusout)="toggleSuggestions(false)"
                            placeholder="FJ-283-ZE"
                        >
                        <div [class.display-none]="vehicleDisplay === false || loading === true" class="suggestions">
                            <div [class.display-none]="options.length === 0" class="arrow"></div>
                            <div [class.display-none]="noResult === false">
                                Pas de résultats
                            </div>
                            <div [class.display-none]="noResult === true && false" *ngFor="let option of options"
                                (click)="setVehicleSearch(option)"
                            >
                                {{ option.name }} | {{ option.brand }} {{ option.model }}
                            </div>
                        </div>
                    </div>
                </div>
                <div uk-grid class="remove-grid-ml-pl uk-grid-small modal-gray-part">
                    <div *ngIf="vehicleSet === false">
                        Aucun utilisateur sélectionné.
                    </div>
                    <div *ngIf="vehicleSet === true">
                        <div class="uk-margin-small-left uk-margin-small-bottom">Vous avez sélectionné</div>
                        <img src="../../../assets/icons/Vehicle.svg" width="40px" height="40px" alt="vehicle"/>
                        <span class="bold uk-margin-small-left">{{ vehicle.name }} <span class="regular">| {{ vehicle.brand }} {{ vehicle.model }}</span></span>
                    </div>
                </div>
                <!--<div uk-grid class="remove-grid-ml-pl uk-grid-small uk-margin-bottom">
                    <div class="uk-width-12-12">
                        <div class="uk-display-inline-block">
                            <label class="uk-form-label uk-display-inline-block vop-blue bold uk-margin-small-left uk-margin-small-right" for="form-stacked-text">
                                Recherche
                            </label>
                            <div class="uk-form-controls uk-display-inline-block uk-position-relative">
                                <span *ngIf="loading === false" class="uk-form-icon uk-form-icon-flip">
                                    <img src="../../../assets/icons/Search.svg" width="24px" height="24px" alt="user"/>
                                </span>
                                <span *ngIf="loading === true" class="uk-form-icon uk-form-icon-flip">
                                    <div style="width:24px; height: 24px;" uk-spinner></div>
                                </span>
                                <input class="input alt bold color-cold-grey" type="text" [(ngModel)]="vehicleSearch"
                                    (ngModelChange)="updateUserOptionList($event)"
                                    (focus)="toggleSuggestions(true)" (focusout)="toggleSuggestions(false)"
                                    placeholder="John Doe" style="width: 250px;"
                                >
                                <div [class.display-none]="vehicleDisplay === false || loading === true" class="suggestions">
                                    <div [class.display-none]="options.length === 0" class="arrow"></div>
                                    <div [class.display-none]="noResult === false">
                                        Pas de résultats
                                    </div>
                                    <div [class.display-none]="noResult === true" *ngFor="let option of options"
                                        (click)="setvehicleSearch(option)"
                                    >
                                        {{ option.FirstName }} {{ option.LastName }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>-->
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button">Annuler</button>
                <button [disabled]="vehicleSet === false" (click)="sendUser()" class="button bold uk-margin-small-left" type="button">
                    Ajouter
                </button>
            </p>
        </div>
    </div>
</div>